export const extractRest = ({ basePath, record, resource, ...notImportant }) => ({
  basePath,
  record,
  resource
});

export default extractRest;
